module.exports = __webpack_public_path__ + "static/img/wechat.da32ce90.jpg";